import React, {Component} from 'react';
import {Doughnut, Polar, HorizontalBar} from 'react-chartjs-2';
import {Popover, PopoverHeader, PopoverBody} from 'reactstrap';

import {
        COLORS,
        DIET_IMAGES,
        ALLERGEN_IMAGES,        
        ID_ENUMS,
        NO_LOCATION_TEXT,
        SAMPLE_DATA
} from './constants';

import { maxLabelFinder } from '../../config';



class Free extends Component {
  constructor(props) {
    super(props);
    this.state = {
      weekly: false,
      monthly: true,
      yearly: false,
      dietFirst: false,
      clickData:null,
      dietLabels: [],
      dietData: [],
      allergenLabels:[],
      allergenData:[],
      auditLabels:[],
      auditData:[],
      clickPopOverOpen: false,
      dietPopOverOpen: false,
      allergenPopOverOpen: false,
      auditPopOverOpen: false
  }  
  }



  get upgradeNotice() {
    if (this.props.client && this.props.client.plan)
      return null;

    return (
      <div className="alert alert-primary show">
        Viewing basic Analytics. For deep insights please
            <a href="https://honeycomb.ai/upgrade" className="alert-link"> contact us </a>
        about upgrading to Honeycomb Premium.
            <a href="https://honeycomb.ai/upgrade" className="alert-link"> Upgrade Now!</a>
      </div>
    )
  }

     /**
     * Toogle pop over associated with a particular id
     * @param id : id of popover
     */
    toggle(id) {
      switch(id){
          case ID_ENUMS.CLICKS_POPOVER_ID:
              this.setState({
                  clickPopOverOpen: !this.state.clickPopOverOpen
              });
              break;
          case ID_ENUMS.DIET_POPOVER_ID:
              this.setState({
                  dietPopOverOpen: !this.state.dietPopOverOpen
              });
              break;
          case ID_ENUMS.ALLERGEN_POPOVER_ID:
              this.setState({
                  allergenPopOverOpen: !this.state.allergenPopOverOpen
              });
              break;
          case ID_ENUMS.AUDIT_POPOVER_ID:
              this.setState({
                  auditPopOverOpen: !this.state.auditPopOverOpen
              });
              break;
          default:
              break;

      }
  }
  

  /**
   * Callback for when data time frame is changed
   * @param {int} id : id of time frame : (weekly, monthly, yearly)  
   */
  handleTimeFrameChange(id){
      let clickData      = this.getClickData(id);
      let dietData       = this.getDietData(id);
      let allergenData   = this.getAllergenData(id);        
      if(clickData == null || dietData == null || allergenData == null) return;

      let dietLabels     = dietData[0];
      dietData           = dietData[1];
      let allergenLabels = allergenData[0];
      allergenData       = allergenData[1];

      let weekly         = (id == ID_ENUMS.WEEKLY_ID)  ? true : false;
      let monthly        = (id == ID_ENUMS.MONTHLY_ID) ? true : false;
      let yearly         = (id == ID_ENUMS.YEARLY_ID)  ? true : false;

      this.setState({
              allergenData,
              allergenLabels,
              clickData,
              dietData,
              dietLabels,
              weekly, 
              monthly, 
              yearly
          })
  }


  /**
   * Renders time frame selection buttons (weekly, yearly, monthly)
   */
  get filterButtons(){
      return(
      <div className="card">
          <div className="card-header trendTitle">
              FILTER DATA
          </div>
          <div className="card-body">
              <div className="chart-wrapper">
                  <div role="group" className="btn-group filter-btn-group">
                      {this.state.weekly ? 
                          <button className="btn btn-primary">
                          Weekly 
                          </button>
                      : <button 
                          className="btn btn-secondary"
                          onClick={()=> this.handleTimeFrameChange(ID_ENUMS.WEEKLY_ID)}
                        > Weekly
                        </button>
                      }

                      {this.state.monthly ? 
                          <button className="btn btn-primary">
                          Monthly 
                          </button>
                      : <button 
                          className="btn btn-secondary"
                          onClick={()=> this.handleTimeFrameChange(ID_ENUMS.MONTHLY_ID)}
                        > Monthly
                        </button>
                      }

                      {this.state.yearly ? 
                          <button className="btn btn-primary">
                          Yearly
                          </button>
                      : <button 
                          className="btn btn-secondary"
                          onClick={()=> this.handleTimeFrameChange(ID_ENUMS.YEARLY_ID)}
                        > Yearly
                        </button>
                      }
                  </div>
              </div>
          </div>
      </div>
      )
  }

  /**
   * Renders chart to show allergen distribution
   */
  getAllergenDistributionGraph(){
      const data= {
              labels: SAMPLE_DATA.ALLERGEN_LABELS,
              datasets: [{
                  label: 'User Avoiding',
                  data: SAMPLE_DATA.ALLERGEN_DATA,
                  backgroundColor: COLORS.ALLERGEN_BACKGROUND,
                  borderColor: COLORS.ALLERGEN_BODY,
                  borderWidth: 4
              }]
      }

      const options = {
          legend: {
              display: false,
          }
      }
      return (
          <div>
            <Doughnut data={data} options={options} />
          </div>
      )
  }

  /**
   * Renders chart to show diet distribution
   */
  dietDistributionChart(){
      const data = {
          labels: SAMPLE_DATA.DIET_LABELS,
          datasets: [{
              label: '% of Users',
              data: SAMPLE_DATA.DIET_DATA,
              backgroundColor: COLORS.DIET_BACKGROUND,
              borderColor: COLORS.DIET_BORDER,
              borderWidth: 1
          }]
      }
      const options ={
          legend: {
              position: 'bottom'
           },
           layout: {
               padding:{
                  top: 5
               }
           }
      }
      return (
          <div>
            <Polar data={data} options={options} />
          </div>
      )
  }

  /**
   * Determine the id of the current time stamp
   * @return trendID ID to identify current time stamp
   */
  getTimeStampID(){
      let trendID;
      if (this.state.yearly) trendID = ID_ENUMS.YEARLY_ID;
      if (this.state.monthly) trendID = ID_ENUMS.MONTHLY_ID;
      if (this.state.weekly) trendID = ID_ENUMS.WEEKLY_ID;
      return trendID;
  }

  /**
   * Renders diet trends widgets
   */
  getDietTrend(){

      let dietData = this.getDietData(this.getTimeStampID());

      if (!Array.isArray(dietData) || !dietData.length) return null;

      let dietLabels = dietData[0];
      dietData = dietData[1];

      let maxDiet = maxLabelFinder(dietData, dietLabels);

      return(
              <div className="card">
                  <div className="card-body trendCard">
                      <h5 className="trendTitle">Top Diet</h5>
                      <div className="trendImage">
                          <img src={DIET_IMAGES[maxDiet]} width="53"/>
                      </div>
                      <h4 className="trendContent">{maxDiet}</h4>  
                  </div>
              </div>
      )
  }


   /**
   * Renders allergens trends widgets
   */
  getAllergenTrend(){
      let allergenData = this.getAllergenData(this.getTimeStampID());
      if (!Array.isArray(allergenData) || !allergenData.length)  return null;

      let allergenLabels = allergenData[0];
      allergenData = allergenData[1];

      let maxAllergen = maxLabelFinder(allergenData, allergenLabels);

      return(
          
              <div className="card">
                  <div className="card-body trendCard">
                      <h5 className="trendTitle">Top Allergen</h5>
                      <div className="trendImage">
                          <img src={ALLERGEN_IMAGES[maxAllergen]} width="53"/>
                      </div>
                      <h4 className="trendContent">{maxAllergen}</h4>  
                  </div>
              </div>
      )
  }

  /**
   * Renders chart to show menu audit
   */
  getAuditBarGraph(){
      const data =  {
          labels: ["Vegan", "Vegetarian", "Gluten-Free", "Paleo", "Keto", "FODMAP"],
          datasets: [{
              data: [7, 8, 3, 5, 2, 1],
              backgroundColor: COLORS.AUDIT_BACKGROUND,
              borderColor: COLORS.AUDIT_BORDER,
              borderWidth: 1
          }]
      }
      const options = {
          scales: {
              xAxes: [{
                  gridLines:{
                      lineWidth: 0,
                      color: '#fff'
                  },
                  ticks: {
                      min:0,
                      max:10
                  }
              }],
              yAxes: [{
                  gridLines:{
                      lineWidth: 0,
                      color: '#fff'
                  },
                  ticks: {
                      min:0,
                      max:10
                  }
              }]
             
          },
          legend:{
              display: false
          }
      }
      return (
          <div>
              <HorizontalBar data={data} options={options} />
          </div>
      )
  }

  

  /**
   * Gets associated click data for specified time frame
   * @param {int} timeFrame : time frame to get data for
   * @return click data for specified time frame     
   */
  getClickData(timeFrame){
      if (!this.props.clicks) return;
      switch (timeFrame){
          case ID_ENUMS.WEEKLY_ID:
              return this.props.clicks.weekly;
          case ID_ENUMS.MONTHLY_ID:
              return this.props.clicks.monthly;
          case ID_ENUMS.YEARLY_ID:
              return this.props.clicks.yearly;
          default:
              break;
      }
  }

  /**
   * Gets associated diet data for specified time frame
   * @param {int} timeFrame : time frame to get data for
   * @return diet data for specified time frame     
   */
  getDietData(timeFrame){
      if(!this.props.diets) return;
      switch (timeFrame){
          case ID_ENUMS.WEEKLY_ID:
              return [Object.keys(this.props.diets.weekly), 
                  Object.values(this.props.diets.weekly)];
          case ID_ENUMS.MONTHLY_ID:
              return [Object.keys(this.props.diets.monthly), 
                  Object.values(this.props.diets.monthly)];
          case ID_ENUMS.YEARLY_ID:
              return [Object.keys(this.props.diets.yearly), 
                  Object.values(this.props.diets.yearly)];
          default:
              break;
      }
  }

  /**
   * Gets associated allergen data for specified time frame
   * @param {int} timeFrame : time frame to get data for
   * @return allergen data for specified time frame     
   */
  getAllergenData(timeFrame){
      if (!this.props.allergens) return;
      switch (timeFrame){
          case ID_ENUMS.WEEKLY_ID:
              return [Object.keys(this.props.allergens.weekly), 
                  Object.values(this.props.allergens.weekly)];
          case ID_ENUMS.MONTHLY_ID:
              return [Object.keys(this.props.allergens.monthly), 
                  Object.values(this.props.allergens.monthly)];
          case ID_ENUMS.YEARLY_ID:
              return [Object.keys(this.props.allergens.yearly), 
                  Object.values(this.props.allergens.yearly)];
          default:
              break;
      }
  }

  


  /**
   * Renders component to display click data
   */
  get clicks(){
      return(
          <div className="text-white bg-primary card">
              <div className="pb-0 card-body trendCard">
                  <div className="trendTitle"> Menu Views </div>
                  <div className="trendNumber">{this.state.clickData ? this.state.clickData :  0}</div>
                  <div class="trendContent"> {this.timePeriodString}</div>
              </div>
          </div>
      );
  }

  /**
   * Renders week, month or year  
   */
  get timePeriodString(){
      if(this.state.weekly == true){
          return(
              <div class="timePeriod">
                  THIS WEEK
              </div>
          )
      }
      if(this.state.monthly == true){
          return(
              <div class="timePeriod">
                  THIS MONTH
              </div>
          )
      }
      if(this.state.yearly == true){
          return(
              <div class="timePeriod">
                  THIS YEAR
              </div>
          )
      }
      
  }

  notEnoughDataRender() {
    return (
    <div className="notEnoughData">
            <div className="card">
                <div className="clearfix p-0 card-body">
                <i className="fa fa-lock bg-primary p-4 px-5 font-2xl mr-3 float-left" />
                <div className="h5 mb-0 text-primary pt-3">
                    Not Enough Data
                </div>
                <div className="text-muted text-uppercase font-weight-bold font-xs">
                    Wait or change button placement
                </div>
                </div>
            </div>
    </div>
    )
  }

  get diets(){
      return (
        <div className="card">
          <div className="card-header trendTitle">
                  DIET DISTRIBUTION
                  <img 
                      className="popover-icon" 
                      src="img/info-button.png" 
                      width ="20" 
                      id={'Popover-' + ID_ENUMS.DIET_POPOVER_ID.toString()} 
                      onClick={() => this.toggle(ID_ENUMS.DIET_POPOVER_ID)}
                      onMouseOver={() => this.toggle(ID_ENUMS.DIET_POPOVER_ID)}
                      onMouseOut={() => this.toggle(ID_ENUMS.DIET_POPOVER_ID)}
                   /> 
                  <Popover 
                      placement="right" 
                      isOpen={this.state.dietPopOverOpen} 
                      target={'Popover-' + ID_ENUMS.DIET_POPOVER_ID.toString()} 
                      toggle={() =>this.toggle(ID_ENUMS.DIET_POPOVER_ID)}
                      >
                      <PopoverHeader>
                          Information
                      </PopoverHeader>
                      <PopoverBody> 
                          This chart shows you proportionally what diets
                           users who are filtering your Diet Friendly 
                           Menu are on. Upgrade now to be able to see the exact 
                           number of people filtering your menu using a certain diet. 
                      </PopoverBody>
                  </Popover>
          </div>
          <div className="card-body">
            {this.premiumFeature()}
            <div className="chart-wrapper">
              <div className="Overlay">
                  &nbsp;
              </div>
              {this.dietDistributionChart()}
            </div>
          </div>
        </div>
      )
  }

  get allergens(){
      return (
        <div className="card">
          <div className="card-header trendTitle">
              ALLERGEN DISTRIBUTION
              <img 
                  className="popover-icon" 
                  src="img/info-button.png" 
                  width ="20" 
                  id={'Popover-' + ID_ENUMS.ALLERGEN_POPOVER_ID.toString()} 
                  onClick={() => this.toggle(ID_ENUMS.ALLERGEN_POPOVER_ID)} 
                  onMouseOver={() => this.toggle(ID_ENUMS.ALLERGEN_POPOVER_ID)}
                  onMouseOut={() => this.toggle(ID_ENUMS.ALLERGEN_POPOVER_ID)}
              /> 
              <Popover 
                  placement="right" 
                  isOpen={this.state.allergenPopOverOpen} 
                  target={'Popover-' + ID_ENUMS.ALLERGEN_POPOVER_ID.toString()}
                  toggle={() =>this.toggle(ID_ENUMS.ALLERGEN_POPOVER_ID)}
                  >
                  <PopoverHeader>
                      Information
                  </PopoverHeader>
                  <PopoverBody>
                      This chart shows you proportionally what allergens 
                      users who are filtering your Diet Friendly Menu are have flagged. 
                      Hover over a piece to see the allergen and number of users flagging it. 
                      Change to view weekly, yearly or monthly.
                  </PopoverBody>
              </Popover>
          </div>
          <div className="card-body">
            {this.premiumFeature()}
            <div className="chart-wrapper">
              {this.getAllergenDistributionGraph()}
              <div className="Overlay">
                &nbsp;
               </div>
            </div>
          </div>
        </div>
      )
  }

  get audit(){
      return (
        <div className="card">
          <div className="card-header trendTitle">
              DIET AUDIT
              <img 
                  className="popover-icon" 
                  src="img/info-button.png" 
                  width ="20" id={'Popover-' + ID_ENUMS.AUDIT_POPOVER_ID.toString()} 
                  onClick={() => this.toggle(ID_ENUMS.AUDIT_POPOVER_ID)} 
                  onMouseOver={() => this.toggle(ID_ENUMS.AUDIT_POPOVER_ID)}
                  onMouseOut={() => this.toggle(ID_ENUMS.AUDIT_POPOVER_ID)}
              /> 
              <Popover placement="right" 
                  isOpen={this.state.auditPopOverOpen} 
                  target={'Popover-' + ID_ENUMS.AUDIT_POPOVER_ID.toString()}
                  toggle={() =>this.toggle(ID_ENUMS.AUDIT_POPOVER_ID)}
                  >
                  <PopoverHeader>
                      Information
                  </PopoverHeader>
                  <PopoverBody>
                      This chart shows you a menu score for each 
                      of the major diets out of 10. A 10 means your 
                      menu is super accommodating to these users, a 
                      0 shows that you have no suitable options 
                      for these users.
                  </PopoverBody>
              </Popover>
          </div>
          <div className="card-body">
            {this.premiumFeature()}
            <div className="chart-wrapper">
              {this.getAuditBarGraph()}
              <div className="Overlay">
                &nbsp;
              </div>
            </div> 
          </div>
        </div>
      )
  }

  get clicksDietAllergenGroup(){
    if(this.props.clicks["monthly"] <= 7){
        return(
            <div className="col">
                {this.notEnoughDataRender()}
                <div className="Overlay">
                    &nbsp;
                </div>
                <div className="card-group trends">
                    {this.getDietTrend()}
                    {this.getAllergenTrend()}
                    {this.clicks}
                </div>
            </div>
        )
    }
    else{
        return(
            <div className="mb-4 card-group trends">
                {this.getDietTrend()}
                {this.getAllergenTrend()}
                {this.clicks}
            </div>
        )
    }
}

  componentWillReceiveProps(){
      if(this.props.clicks){
          this.handleTimeFrameChange(ID_ENUMS.MONTHLY_ID);
      }
      else{
      }
  }

  premiumFeature() {
    return (
      <div className="card premiumFeature">
        <div className="clearfix p-0 card-body">
          <i className="fa fa-lock bg-primary p-4 px-5 font-2xl mr-3 float-left" />
          <div className="h5 mb-0 text-primary pt-3">
            Premium Feature
            </div>
          <div className="text-muted text-uppercase font-weight-bold font-xs">
            Upgrade for more insights!
            </div>
        </div>
      </div>
    )
  }

    /*
     * Renders location picker
     */
    get restaurantList(){
        if (!this.props.client || !this.props.client.locations) return null;
        let restaurantList = [];
        for(let i =0; i<this.props.client.locations.length; i++){
          if (i == this.props.activeLocation){
            restaurantList.push(
              <span 
                className="active list-group-item-action list-group-item"
                key={i}
              >
                {this.props.client.locations[i]["name"] + ' | ' + 
                  this.props.client.locations[i]["address"]}
              </span>
            )
          }
          else {
            restaurantList.push(
              <span 
                className="list-group-item-action list-group-item"
                key={i}
                onClick={()=>this.props.updateActiveLocation(i)}
              >
                {this.props.client.locations[i]["name"] + ' | ' + 
                  this.props.client.locations[i]["address"]}
              </span>
            )
          }
        }
        return restaurantList;
    }

    get locationListRender() {
        if(this.props.client && this.props.client.locations && this.props.client.locations.length > 0){
        return (
            <div className="row">
                <div className="card">
                    <div className="card-header trendTitle">
                        SELECT A LOCATION
                    </div>
                    <div className="card-body noMargin noPadding">
                        <div className="chart-wrapper">
                            <div className="list-group-no-margin restaurantList">
                                <ul>
                                    {this.restaurantList}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}
        else if (this.props.client && this.props.client.locations && this.props.client.locations.length == 0){
          return(
            <div className="row">
              <div className="card">
                <div className="card-header">
                  Select a Location
                <div className="card-body">
                  <p className="centered-row"> Added Locations will appear here.</p>
                </div>  
                </div>
              </div>
            </div>
          )
        }
    } 

    render() {
        return (
            <div className="animated fadeIn">
                <div className="row card-columns">
                    {this.upgradeNotice}
                    {/* <div className="row noMargin">
                        <div className="col-lg-12">
                            {this.locationListRender}
                        </div>
                    </div> */}

                    <div className="row noMargin">
                        <div className="col-xl-6 col-lg-12">
                            {this.filterButtons}
                        </div>
                        <div className="col-xl-6 col-lg-12">
                            {this.clicksDietAllergenGroup}
                        </div>
                    </div>

                    <div className="row noMargin">
                        <div className="col-xl-6 col-lg-12">
                            {this.diets}
                        </div>
                        <div className="col-xl-6 col-lg-12">
                            {this.allergens}
                        </div>
                    </div>

                    <div className="row noMargin">
                        <div className="col-xl-6 col-lg-12">
                            {this.audit}
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default Free;


// WEBPACK FOOTER //
// ./src/views/Analytics/free.js